import { useEffect } from 'react';
import CustomCursor from '@/components/feature/CustomCursor';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import BenefitStrip from './components/BenefitStrip';
import HowItWorks from './components/HowItWorks';
import CostComparison from './components/CostComparison';
import AlreadyPrepared from './components/AlreadyPrepared';
import Coverage from './components/Coverage';
import MembershipApp from './components/MembershipApp';
import EmotionalImpact from './components/EmotionalImpact';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Home() {
  useScrollReveal();

  useEffect(() => {
    // Parallax on scroll
    const handleScroll = () => {
      const scrollY = window.scrollY;
      document.querySelectorAll<HTMLElement>('.parallax-bg').forEach((el) => {
        el.style.transform = `translateY(${scrollY * 0.25}px)`;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <CustomCursor />
      <Navbar />
      <Hero />
      <BenefitStrip />
      <AlreadyPrepared />
      <HowItWorks />
      <Coverage />
      <CostComparison />
      <MembershipApp />
      <EmotionalImpact />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
